import { DraftWaypointStatus, GenericStatusInfoTitle, GenericStatusIndicator, ProcedureStatus } from '@caresend/types';
import { getFedExTrackingURL, objectFilter } from '@caresend/utils';
import { getLocalDraftWaypointDispatchSteps } from '../../../components/specific/DraftWaypointDetails/subComponents/StepperStatus/get.js';

const getLocalCanceledProcedureData = (denormalizedDraftWaypoint, proceduresToNotCancel) => {
    const allProcedureData = denormalizedDraftWaypoint.patientProcedureData;
    if (!allProcedureData)
        return undefined;
    const proceduresToCancel = objectFilter(allProcedureData.procedures, (procedureInfo) => !(proceduresToNotCancel === null || proceduresToNotCancel === void 0 ? void 0 : proceduresToNotCancel.includes(procedureInfo.id)));
    const newProcedureData = {};
    Object.values(proceduresToCancel).forEach((procedureInfo) => {
        newProcedureData[procedureInfo.id] = {
            ...procedureInfo,
            status: ProcedureStatus.CANCELED,
        };
    });
    return {
        ...allProcedureData,
        procedures: newProcedureData,
    };
};
/**
 * Using the old denormalized draft waypoint and the canceled object,
 * update the denormalized draft waypoint for display in the visit list/page
 * while algolia updates.
 */
const getLocalDenormalizedDraftWaypointForCancelation = (canceled, oldDenormalizedDraftWaypoint, proceduresToNotCancel) => {
    const canceledDenormalizedDraftWaypoint = {
        ...oldDenormalizedDraftWaypoint,
        canceled,
        status: DraftWaypointStatus.CANCELED,
        statusInfo: {
            title: GenericStatusInfoTitle.CANCELED,
            color: GenericStatusIndicator.RED,
        },
    };
    const localDraftWaypoint = {
        ...canceledDenormalizedDraftWaypoint,
        dispatchSteps: getLocalDraftWaypointDispatchSteps(canceledDenormalizedDraftWaypoint),
        isLocalData: true,
        patientProcedureData: getLocalCanceledProcedureData(oldDenormalizedDraftWaypoint, proceduresToNotCancel),
    };
    return localDraftWaypoint;
};
const getLocalDenormalizedDraftWaypointForSampleTrackingNumberUpdate = (updatedShipmentInfos, oldDenormalizedDraftWaypoint) => {
    var _a;
    const currentPatientProcedureData = oldDenormalizedDraftWaypoint.patientProcedureData;
    if (!currentPatientProcedureData)
        throw Error('Missing patient procedure data');
    const updatedSampleTrackingURLs = {
        ...(_a = currentPatientProcedureData.shipmentTracking) === null || _a === void 0 ? void 0 : _a.sampleTrackingURLs,
    };
    updatedShipmentInfos.forEach((shipmentInfo) => {
        const { bookingID, trackingNumber } = shipmentInfo;
        if (trackingNumber) {
            updatedSampleTrackingURLs[bookingID] = getFedExTrackingURL(trackingNumber);
        }
        else {
            delete updatedSampleTrackingURLs[bookingID];
        }
    });
    const updatedShipmentTracking = {
        ...currentPatientProcedureData.shipmentTracking,
        sampleTrackingURLs: updatedSampleTrackingURLs,
    };
    const updatedPatientProcedureData = {
        ...currentPatientProcedureData,
        shipmentTracking: updatedShipmentTracking,
    };
    const updatedDraftWaypoint = {
        ...oldDenormalizedDraftWaypoint,
        patientProcedureData: updatedPatientProcedureData,
    };
    return updatedDraftWaypoint;
};

export { getLocalDenormalizedDraftWaypointForCancelation, getLocalDenormalizedDraftWaypointForSampleTrackingNumberUpdate };
